import TemplateIcon from "../svg/LandingTemplateIcon.svg"
const Icon = () => {
    return (
   
  <img src={TemplateIcon} />


    )
  }
  export default Icon;